import React from "react";
import { AppLayoutProps } from "./types";
import { AppLayoutStyled } from "./styles";
import Navbar from "../components/navbar/navbar";
import { isSomething } from "../utils/common-utils";
import { useAppSelector } from "../store/hooks";
import NotificaionsWrapper from "../components/notification/notification-wrapper";

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  isHideNavbar = false,
}) => {
  const notifications = useAppSelector((state) => state.UI.notifications);

  return (
    <AppLayoutStyled isHideNavbar={isHideNavbar}>
      {!isHideNavbar && <Navbar isLoggedIn={true} />}
      {isSomething(notifications) && <NotificaionsWrapper />}
      {children}
    </AppLayoutStyled>
  );
};

export default AppLayout;
